import { Loader } from 'shared/components/Loader';

import { useGetUser, useGetSchool, useGetTranslation } from './hooks';

import type { FC, PropsWithChildren as PrefetchProviderProps } from 'react';

export const PrefetchProvider: FC<PrefetchProviderProps> = ({ children }) => {
  const { isLoading: userLoading } = useGetUser();
  const { isLoading: schoolSettingsLoading } = useGetSchool();
  const { isLoading: translationLoading } = useGetTranslation();

  if (userLoading || schoolSettingsLoading || translationLoading) {
    return <Loader />;
  }

  return <>{children}</>;
};
